import dayjs from "dayjs";
import PropTypes from "prop-types";
import { FormProvider, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import Grid from "@mui/material/Grid";

import { CenteredLoading } from "@/features/ui";

import { GeneralInformationSection } from "./general-information-section";
import { OtherSection } from "./other-section";
import {
  DEFAULT_VALUES,
  VALIDATION_SCHEMA,
} from "./sales-down-payment-form-constants";
import { SelectSalesOrderSection } from "./select-sales-order-section";

export const SalesDownPaymentForm = ({
  defaultValues,
  onSubmit,
  renderActionButton,
  editMode = false,
  isLoading = false,
}) => {
  const methods = useForm({
    defaultValues: defaultValues
      ? { ...DEFAULT_VALUES, ...defaultValues }
      : DEFAULT_VALUES,
    resolver: yupResolver(VALIDATION_SCHEMA),
  });
  const { handleSubmit, formState } = methods;

  const onFormSubmit = async (formData) => {
    const payload = {
      sellerId: formData.seller.id,
      salesOrderId: formData.salesOrder.id,
      transactionDate: dayjs(formData.transactionDate).format("YYYY-MM-DD"),
      amount: formData.amount,
      paymentTermId: formData.paymentTerm?.id ?? null,
      note: formData.note || null,
    };

    await onSubmit(payload);
  };

  return isLoading ? (
    <CenteredLoading sx={{ height: "100vh" }} />
  ) : (
    <FormProvider {...methods}>
      <Grid
        container
        component="form"
        noValidate
        onSubmit={handleSubmit(onFormSubmit)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
          }
        }}
        spacing={2.5}
      >
        <Grid size={{ xs: 12 }}>
          <GeneralInformationSection editMode={editMode} />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <SelectSalesOrderSection editMode={editMode} />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <OtherSection />
        </Grid>
        <Grid
          size={{ xs: 12 }}
          sx={{
            display: "flex",
            justifyContent: "flex-end"
          }}>
          {renderActionButton({ isSubmitting: formState.isSubmitting })}
        </Grid>
      </Grid>
    </FormProvider>
  );
};

SalesDownPaymentForm.propTypes = {
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
  renderActionButton: PropTypes.func,
  editMode: PropTypes.bool,
  isLoading: PropTypes.bool,
};
